import { Selector } from '@ngxs/store';

import { getLanguageName } from '@customer-portal/shared';

import { LanguageListItemModel } from '../../models';
import { GlobalState, GlobalStateModel } from '../global.state';

export class GlobalLanguagesSelectors {
  @Selector([GlobalLanguagesSelectors._languageList])
  static languageList(
    languageList: LanguageListItemModel[],
  ): LanguageListItemModel[] {
    return languageList;
  }

  @Selector([GlobalLanguagesSelectors._languageList])
  static formattedLanguagesList(
    languageList: LanguageListItemModel[],
  ): LanguageListItemModel[] {
    return languageList.map((lang) => ({
      ...lang,
      languageName: getLanguageName(lang.languageName),
    }));
  }

  @Selector([GlobalLanguagesSelectors._languageListLoaded])
  static languageListLoaded(isLoaded: boolean): boolean {
    return isLoaded;
  }

  @Selector([GlobalLanguagesSelectors._languagesListLoadingError])
  static languageListLoadedError(loadError: string): string {
    return loadError;
  }

  @Selector([GlobalState])
  private static _languageList(
    state: GlobalStateModel,
  ): LanguageListItemModel[] {
    return state.languages.languagesList;
  }

  @Selector([GlobalState])
  private static _languageListLoaded(state: GlobalStateModel): boolean {
    return state.languages.loaded;
  }

  @Selector([GlobalState])
  private static _languagesListLoadingError(state: GlobalStateModel): string {
    return state.languages.loadingError ?? '';
  }
}
